export default __webpack_public_path__ + "static/richmond-sponsorship-dacc52e0fc81237b3263b1cd07d35c2e.jpg";